var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooksSideBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 5.83333C1.66797 4.66656 1.66797 4.08317 1.89504 3.63752C2.09478 3.24552 2.41349 2.92681 2.80549 2.72707C3.25114 2.5 3.83453 2.5 5.0013 2.5C6.16808 2.5 6.75147 2.5 7.19712 2.72707C7.58912 2.92681 7.90783 3.24552 8.10757 3.63752C8.33464 4.08317 8.33464 4.66656 8.33464 5.83333V14.1667C8.33464 15.3334 8.33464 15.9168 8.10757 16.3625C7.90783 16.7545 7.58912 17.0732 7.19712 17.2729C6.75147 17.5 6.16808 17.5 5.0013 17.5C3.83453 17.5 3.25114 17.5 2.80549 17.2729C2.41349 17.0732 2.09478 16.7545 1.89504 16.3625C1.66797 15.9168 1.66797 15.3334 1.66797 14.1667V5.83333Z",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.166H5.00748",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 5.83398H8.33464",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54179 6.89036C9.24604 5.78198 9.09821 5.2278 9.20004 4.74666C9.28963 4.32343 9.51029 3.93956 9.83054 3.65004C10.1945 3.3209 10.7465 3.17241 11.8502 2.87542C12.954 2.57843 13.5059 2.42994 13.985 2.53221C14.4065 2.62217 14.7887 2.8438 15.077 3.16534C15.4048 3.53088 15.5527 4.08507 15.8485 5.19344L17.9608 13.1097C18.2565 14.218 18.4044 14.7722 18.3025 15.2533C18.213 15.6766 17.9923 16.0604 17.672 16.35C17.308 16.6791 16.7561 16.8276 15.6524 17.1246C14.5486 17.4216 13.9967 17.5701 13.5176 17.4678C13.0961 17.3778 12.7139 17.1562 12.4255 16.8347C12.0978 16.4691 11.9499 15.9149 11.6541 14.8066L9.54179 6.89036Z",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8164 13.9121L14.8237 13.9102",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66682L15.4167 5",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksSideBarIcon);
export default __webpack_public_path__ + "static/media/books-side-bar-icon.a5ef474fd3343e42b41ee7e64ac5935a.svg";
export { ForwardRef as ReactComponent };